import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";

Vue.use(Vuex);
Axios.defaults.baseURL = "https://inova-token-controller.fly.dev/";
// Axios.defaults.baseURL = "http://localhost:8080/";

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("acess_token") || null,
    filter: "all",
    todos: [],
    groups: [],
    reports: [],
    embedTokens: [],
    customers: [],
    currentUser: null,
    profiles: [],
    availableFeatures: null,
  },
  getters: {
    getEmbedTokens(state) {
      return state.embedTokens;
    },
    getReports(state) {
      return state.reports;
    },
    getGroups(state) {
      return state.groups;
    },
    loggedIn(state) {
      return state.token != null;
    },
    remaining(state) {
      return state.todos.filter(todo => !todo.completed).length;
    },
    anyRemaining(state, getters) {
      return getters.remaining != 0;
    },
    todosFiltered(state) {
      if (state.filter == "all") {
        return state.todos;
      } else if (state.filter == "active") {
        return state.todos.filter(todo => !todo.completed);
      } else if (state.filter == "completed") {
        return state.todos.filter(todo => todo.completed);
      } else {
        return state.todos;
      }
    },
    showClearCompletedButton(state) {
      return state.todos.filter(todo => todo.completed).length > 0;
    },
    getCustomers(state) {
      return state.customers;
    },
    getCurrentUser(state) {
      return state.currentUser;
    },
    userIsAdmin(state) {
      if (!state.currentUser) {
        return false;
      }
      return state.currentUser.authorities.includes("ROLE_ADMIN");
    },
    getProfiles(state){
      return state.profiles;
    },
    getAvailableFeatures(state) {
      return state.availableFeatures;
    },
  },
  mutations: {
    retrieveReports(state, reports) {
      state.reports.push(...reports);
    },
    retrieveGroups(state, groups) {
      state.groups = groups;
    },
    retrieveAvailableFeatures(state, availableFeatures) {
      state.availableFeatures = availableFeatures;
    },
    retrieveTodos(state, todos) {
      state.todos = todos;
    },
    addTodo(state, todo) {
      state.todos.push({
        id: todo.id,
        title: todo.title,
        completed: false,
        editing: false
      });
    },
    clearCompleted(state) {
      state.todos = state.todos.filter(todo => !todo.completed);
    },
    changeFilter(state, filter) {
      state.filter = filter;
    },
    checkAll(state, checked) {
      state.todos.forEach(todo => (todo.completed = checked));
    },
    deleteTodo(state, id) {
      const index = state.todos.findIndex(item => item.id == id);
      state.todos.splice(index, 1);
    },
    updateTodo(state, todo) {
      const index = state.todos.findIndex(item => item.id == todo.id);
      state.todos.splice(index, 1, {
        id: todo.id,
        title: todo.title,
        completed: todo.completed,
        editing: todo.editing
      });
    },
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      localStorage.removeItem("acess_token");
      state.token = null;
      state.currentUser = null;
      state.groups = [],
        state.reports = [],
        state.customers = [],
        state.embedTokens = []
    },
    retrieveEmbedToken(state, embedToken) {
      state.embedTokens.push(embedToken);
    },
    retrieveCustomers(state, customers) {
      state.customers = customers.sort((a, b) => {
        const aName = a.fullName.toLowerCase();
        const bName = b.fullName.toLowerCase();
        if(aName === bName) return 0;
        return aName > bName ? 1 : -1;
      });
    },
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setProfiles(state, profiles){
      state.profiles = profiles.sort((a, b) => {
        const aName = a.name.toLowerCase();
        const bName = b.name.toLowerCase();
        if(aName === bName) return 0;
        return aName > bName ? 1 : -1;
      });
    },
    addExtraAuthority(state, data){
      state.customers.find(c => c.id === data.userId).extraAuthorities.push(data.reportId);
    },
    removeExtraAuthority(state, data){
      const authorities = state.customers.find(c => c.id === data.userId).extraAuthorities;
      const index = authorities.findIndex(auth => auth === data.reportId);
      authorities.splice(index, 1);
    }
  },
  actions: {
    retrieveEmbedToken(context, report) {
      Axios.get(
        "/pbi/groups/" +
        report.groupId +
        "/reports/" +
        report.reportId +
        "/GenerateToken",
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      )
        .then(response => {
          context.commit("retrieveEmbedToken", response.data);
        })
        .catch(error => {
          context.commit("destroyToken");
          console.log(error);
        });
    },
    retrieveReports(context, groupId) {
      Axios.get("/pbi/groups/" + groupId + "/reports", {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(response => {
          context.commit("retrieveReports", response.data);
        })
        .catch(error => {
          context.commit("destroyToken");
          console.log(error);
        });
    },
    retrieveGroups(context) {
      Axios.get("/pbi/groups", {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(response => {
          context.commit("retrieveGroups", response.data);
        })
        .catch(error => {
          context.commit("destroyToken");
          console.log(error);
        });
    },
    retrieveAvailableFeatures(context) {
      Axios.get("/pbi/availableFeatures", {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(response => {
          console.log(response.data)
          context.commit("retrieveAvailableFeatures", response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    register(context, data) {
      return new Promise((resolve, reject) => {
        Axios.post(
          "/customers",
          {
            username: data.username,
            fullName: data.fullName,
            extraInfo: data.extraInfo,
            email: data.email,
            password: data.password,
            profileId: data.profileId
          },
          {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          }
        )
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    retrieveProfiles(context) {
      return new Promise((resolve, reject) => {
        Axios.get("/profiles",
          {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          }
        )
        .then(response =>{
          context.commit("setProfiles", response.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          context.commit("destroyToken");
          reject(error);
        });
      });
    },
    destroyToken(context) {
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Axios.delete("/todoApp/token", {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          })
            .then(response => {
              context.commit("destroyToken");
              resolve(response);
            })
            .catch(error => {
              context.commit("destroyToken");
              reject(error);
            });
        });
      }
    },
    retrieveToken(context, credentials) {
      return new Promise((resolve, reject) => {
        Axios.post(
          "/oauth/token",
          {
            username: credentials.username,
            password: credentials.password
            },
        )
          .then(response => {
            const token = response.data.access_token;

            localStorage.setItem("acess_token", token);
            context.commit("retrieveToken", token);
            context.dispatch("getCurrentUser");
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getCurrentUser(context) {
      Axios.get("/customers/whoAmI", {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(response => {
          context.commit("setCurrentUser", response.data);
        })
        .catch(error => {
          context.commit("destroyToken");
          console.log(error);
        });
    },
    retrieveTodos(context) {
      Axios.get("/todoApp/todos", {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(response => {
          context.commit("retrieveTodos", response.data);
        })
        .catch(error => {
          context.commit("destroyToken");
          console.log(error);
        });
    },
    addTodo(context, todo) {
      Axios.post(
        "/todoApp/todos",
        {
          title: todo.title,
          completed: false
        },
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      )
        .then(response => {
          context.commit("addTodo", response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteTodo(context, id) {
      Axios.delete("/todoApp/todos/" + id, {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(() => {
          context.commit("deleteTodo", id);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateTodo(context, todo) {
      Axios.patch(
        "/todoApp/todos/" + todo.id,
        {
          title: todo.title,
          completed: todo.completed
        },
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      )
        .then(response => {
          context.commit("updateTodo", response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    checkAll(context, checked) {
      Axios.patch(
        "/todoApp/checkAllTodos",
        {
          completed: checked
        },
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      )
        .then(() => {
          context.commit("checkAll", checked);
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearCompleted(context) {
      Axios.delete("/todoApp/todosClearCompleted", {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(() => {
          context.commit("clearCompleted");
        })
        .catch(error => {
          console.log(error);
        });
    },
    retrieveCustomers(context) {
      Axios.get("/customers", {
        headers: {
          Authorization: "Bearer " + context.state.token
        }
      })
        .then(response => {
          context.commit("retrieveCustomers", response.data);
        })
        .catch(error => {
          context.commit("destroyToken");
          console.log(error);
        });
    },
    removeAuthority(context, data) {
      return Axios.delete(
        "/profiles/" + data.profileId + "/authority/" + data.reportId,
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      );
    },
    addAuthority(context, data) {
      return Axios.post(
        "/profiles/" + data.profileId + "/authority/" + data.reportId,
        {},
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      );
    },
    patchUserById(context, data) {
      return new Promise((resolve, reject) => {
        Axios.patch(
          "/customer/" + data.id,
          {
            username: data.username,
            fullName: data.fullName,
            extraInfo: data.extraInfo,
            email: data.email,
            password: data.password,
            profileId: data.profileId
          },
          {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          }
        ).then(response => {
          resolve(response);
        })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    changePassword(context, data) {
      return new Promise((resolve, reject) => {
        Axios.patch(
          "/changePassword",
          {
            oldPassword: data.oldPassword,
            newPassword: data.newPassword
          },
          {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          }
        ).then(response => {
          if(response.data === false){
            reject(response)
          }
          resolve(response);
        })
          .catch(error => {
            reject(error);
          });
      });
    },
    retrieveProfile(context, profileId) {
      return Axios.get(
          "/profiles/" + profileId,
          {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          }
        );
    },
    deleteProfile(context, profileId){
      return Axios.delete(
        "/profiles/" + profileId,
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      );
    },
    createProfile(context, profileName){
      return Axios.post(
        "/profiles",
        {
          id: null,
          name: profileName
        },
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      );
    },
    editProfile(context, data){
      return Axios.patch(
        "/profiles/"+ data.profileId,
        {
          id: data.profileId,
          name: data.profileName
        },
        {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        }
      );
    },
    addExtraAuthority(context, data) {
      return new Promise((resolve, reject) => {
        Axios.post(
          "/customer/" + data.userId + "/authority/" + data.reportId,
          {},
          {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          }
        )
        .then(() =>{
          context.commit("addExtraAuthority", data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    removeExtraAuthority(context, data) {
      return new Promise((resolve, reject) => {
        Axios.delete(
          "/customer/" + data.userId + "/authority/" + data.reportId,
          {
            headers: {
              Authorization: "Bearer " + context.state.token
            }
          }
        )
        .then(() =>{
          context.commit("removeExtraAuthority", data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
  },
  modules: {}
});
